<template>
  <section class="useredit">
    <header class="header">
    </header>

    <form @submit.prevent="handleUpdateUser">
      <f-card>
        <template slot="header"></template>

        <template>
          <div class="row">
            <span class="label">Compte</span>
            <div class="inputs inputs-container">
              <div class="wrap">
                <ab-input id="lastname" type="text" class="input-group mandatory" v-model="lastName" name="lastname" label="Nom"></ab-input>
                <ab-input id="firstname" type="text" class="input-group mandatory" v-model="firstName" name="firstname" label="Prénom"></ab-input>
                <ab-input id="email" type="email" class="input-group mandatory" v-model="email" name="email" label="Email"></ab-input>
                <ab-input type="text" class="input-group" v-model="phone" name="phone" label="Téléphone"></ab-input>
                <f-select
                  v-if="currentUser.role_id == 1"
                  id="role"
                  name="role mandatory"
                  class="input-group"
                  placeholder="Rôle"
                  trackBy="id"
                  label="label"
                  :showLabels="false"
                  v-model="role"
                  :options="roles">
                </f-select>
              </div>
              <div class="file-container flex">
                <div class="filepond-container">
                  <file-pond
                    name="logo"
                    ref="pond"
                    :label-idle="pondLabel"
                    allow-file-type-validation="true"
                    :accepted-file-types="pondAcceptedFileType"
                    v-bind:files="pondFiles">
                  </file-pond>
                </div>
                <div class="img-container">
                    <img :src="image" :alt="`${firstName} - ${lastName}`" @error='defaultImage'/>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <span class="label">Etablissement</span>
            <div class="inputs">
              <f-select
                :multiple="true"
                placeholder="Clients"
                :showLabels="false"
                :limit="0"
                :limitText="limitText"
                trackBy="id"
                label="label"
                v-model="clients"
                :options="clientList">
              </f-select>
            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="row flex flex-space">
            <a class="btn-action white change-pwd" @click="handlePasswordChange()">Réinitialiser le mot de passe</a>
            <div>
              <a class="btn-action" @click="$router.go(-1)">Annuler</a>
              <ab-button class="primary">Sauvegarder</ab-button>
            </div>
          </div>
        </template>
      </f-card>
    </form>
  </section>

</template>

<script>
  import AbInput from '@/components/form/input/ab-input.vue';
  import AbButton from '@/components/form/button/ab-button.vue';
  import FCard from '@/components/layout/card/f-card.vue';
  import { mapState } from 'vuex';
  import vueFilePond from 'vue-filepond';
  // Import FilePond styles
  import 'filepond/dist/filepond.min.css';
  // Import image preview and file type validation plugins
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  // Import error message files
  import messages from '../../../messages/messages.js';

  const FilePond = vueFilePond(FilePondPluginFileValidateType);

  export default {
    name: 'UserEdit',
    components: {
      AbInput,
      AbButton,
      FCard,
      FilePond,
    },
    data() {
      return {
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        role: '',
        image: '',
        clients: [],
        pondLabel: "Insérez une photo de profil ou <u>cliquez ici</u>",
        pondFiles: [],
        pondAcceptedFileType: ['image/png','image/jpeg','image/pdf'],
      }
    },
    mounted() {
      const id = this.$route.params.id;
      this.$store.dispatch('getUser', { id: id });
      this.$store.dispatch('getRoles');
      this.$store.dispatch('getClients');
    },
    computed: {
      ...mapState({ user: state => state.users.user }),
      ...mapState({ currentUser: state => state.user }),
      ...mapState({ roles: state => state.selectors.roles }),
      ...mapState({ clientList: state => state.clients.clients }),
    },
    methods: {
      async handleUpdateUser() {
        const firstname = this.$el.querySelector('#firstname input');
        const lastname = this.$el.querySelector('#lastname input');
        const email = this.$el.querySelector('#email input');
        const role = this.$el.querySelector('#role') ? this.$el.querySelector('#role') : '';

        firstname.classList.remove('error');
        lastname.classList.remove('error');
        email.classList.remove('error');

        if (this.firstName != "" && this.lastName != "" && this.email != "") {

          // Array of clients id
          const clientsArray = (this.clients) ? this.clients.map(client => client.id) : [];
          const id = this.$route.params.id;
          let file = this.$refs.pond.getFile() ? this.$refs.pond.getFile().file : null;
          const fileBase64 = file ? await this.getBase64(file) : null;

          const data = await this.$store.dispatch('updateUser', {
            id: id,
            last_name: this.lastName,
            first_name: this.firstName,
            email: this.email,
            phone: this.phone,
            role: this.role.id,
            clients: clientsArray,
            logo: fileBase64,
          });
          if (data.id) {
            this.displayToast({ message: messages.users.UserEdit.custom.success });
            if (this.currentUser.id == this.$route.params.id) {
              this.$store.dispatch('setUser', { ...data, logo_path: `${data.logo_path}?t=${new Date().getTime()}` });
            }
            this.$router.push({ name: 'UserList' });
          }
        }
        else {
          if (!this.firstName) { firstname.classList.add('error'); }
          if (!this.lastName) { lastname.classList.add('error'); }
          if (!this.email) { email.classList.add('error'); }
          this.displayToast({ message: messages.users.global.custom.mandatory, mode: "error" });
        }
      },
      getBase64(file) {
        return new Promise(function(resolve, reject) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () { resolve(reader.result); };
          reader.onerror = function (error) { reject(error); };
        });
      },
      async handlePasswordChange() {
        const data = await this.$store.dispatch('requestPwdChangeUser', { id: this.$route.params.id });
        if (data) {
          this.displayToast({ message: messages.users.UserEdit.custom.requestPassword });
        }
      },
      defaultImage(e) {
        e.target.src = '/assets/images/default-user.png';
      },
      limitText(count) {
        return `${count} élément${count > 1?'s':''} sélectionné${count > 1?'s':''}`;
      },
    },
    watch: {
      user(newUser, oldUser) {
        this.lastName = newUser.last_name;
        this.firstName = newUser.first_name;
        this.email = newUser.email;
        this.phone = newUser.phone;
        this.role = newUser.Role;
        this.clients = newUser.Client;
        this.image = newUser.logo_path ? process.env.VUE_APP_ROOT_API + newUser.logo_path : '/assets/images/default-user.png';
      }
    }
  }
</script>

<style scoped>
  /* Card display */
  .row {
    margin-bottom: 1.5rem;
  }
  /* Left column of card layout*/
  .row .label {
    font-weight: 600;
    font-size: 15px;
    line-height: 27px;
    vertical-align: top;
  }
  /* Right column of card layout */
  .inputs-container { margin-top: 16px; }
  .wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .input-group {
    width: 45%;
  }
  /* FilePond container */
  .file-container { margin-top: 1rem; }
  .filepond-container {
    background-color: var(--app-white-color);
    width: 80%;
  }
  .img-container {
    width: 20%;
    text-align: center;
  }
  .img-container img {
    border-radius: 50%;
    width: 6rem;
    height: 6rem;
  }
  /* Spacing for each section */
  section {
    margin-bottom: 2.5rem;
  }
  /* Footer */
  .change-pwd { padding: 0; margin: 0; }
  .change-pwd:hover {
    color: var(--app-primary-color);
  }
  footer .btn-action {
    margin-right: 1rem;
    cursor: pointer;
  }
</style>
<style>
  /* Override FilePond style */
  .filepond--drop-label { cursor: pointer; }
  .filepond--drop-label label {
    cursor: inherit;
    font-size: 1rem;
  }
  .filepond--root { margin: 0; }
  .filepond--panel-root {
    background-color: inherit;
    border: dashed 2px var(--app-blue-three);
  }
</style>
